import { TextNodeType } from "@tm/isomorphic-utils";
import { useRef, useState } from "react";
import FormattedText from "../../../FormattedText/FormattedText";
import { Container, HelpText, InlineInput, Label, Wrapper } from "./Styles";

interface TravellerSelectorProps {
  travellerInfo?: {
    label?: TextNodeType | string;
    subTitle?: TextNodeType | string;
    min?: number;
    max?: number;
  };
  travellerCount?: number;
  onTravellerCountChange?: (count: number) => void;
}

export const TravellerSelector = ({
  travellerInfo,
  travellerCount = 1,
  onTravellerCountChange,
}: TravellerSelectorProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (raw === "") {
      onTravellerCountChange?.(0);
      return;
    }
    const parsed = parseInt(raw, 10);
    onTravellerCountChange?.(parsed);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Wrapper>
      <Container
        isFocused={isFocused}
        onClick={() => inputRef.current?.focus()}
      >
        <Label isFocused={isFocused}>
          <FormattedText
            value={travellerInfo?.label || "ENTER NO. OF TRAVELLERS"}
          />
        </Label>
        <InlineInput
          ref={inputRef}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={travellerCount || ""}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          aria-label="Number of travellers"
        />
      </Container>
      {travellerInfo?.subTitle ? (
        <HelpText>
          <FormattedText value={travellerInfo.subTitle} />
        </HelpText>
      ) : null}
    </Wrapper>
  );
};
